import type { LocalizedText } from 'hooks/useDirectoryData/types';

export function localize(text: LocalizedText | undefined, locale: string): string | undefined {
  return text?.[locale] ?? text?.en;
}
